<template>
  <div>Dashboard customer</div>
</template>

<script>
export default {
  created() {},
}
</script>
